"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _propTypes = require("prop-types");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

var _componentSvg = require("@emcm-ui/component-svg");

var _componentSvg2 = _interopRequireDefault(_componentSvg);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj };
}

var Icon = function Icon(props) {
  return _react2.default.createElement(_componentSvg2.default, props, Icon.svg);
};

Icon.propTypes = {
  height: _propTypes2.default.number,
  label: _propTypes2.default.string,
  width: _propTypes2.default.number
};

Icon.displayName = "NucleoSmallUserInterfaceCheckCircle08";

Icon.svg = _react2.default.createElement(
  "svg",
  { viewBox: "0 0 24 24" },
  _react2.default.createElement(
    "g",
    {
      className: "nc-icon-wrapper",
      fill: "none",
      strokeLinecap: "round",
      strokeWidth: "2"
    },
    _react2.default.createElement("path", {
      d: "M6 12l4 4 8-8",
      stroke: "#ff5900",
      "data-color": "color-2"
    }),
    _react2.default.createElement("path", {
      d: "M12 1a11 11 0 1 0 0 22 11 11 0 1 0 0-22z",
      stroke: "#4d4d4d"
    })
  )
);

exports.default = Icon;
